<template>
	<div>
		<div class="filters">
			<!-- 查询 -->
			<el-form :inline="true">
				<el-form-item>
					<el-select v-model="gardenId">
						<el-option v-for="(item,index) in gardenIdList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input class="searchInput" v-model="title" :placeholder="$t('lang.lab_redZoneTitle')"></el-input>
				</el-form-item>
				<el-button type="primary" @click="selectList">{{$t('lang.btn.searchBtn')}}</el-button>
			</el-form>
		</div>

		<el-card>
			<!-- 跳转添加 -->
			<el-button slot="header" size="medium" type="primary" @click="add()">{{$t('lang.btn_add')}}</el-button>
			<!-- 列表 -->
			<el-table :data="redZoneList" class="wid100" :height="redZoneList.length > 0 ? 529 : 109">
				<el-table-column type="index" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
				<el-table-column prop="title" :label="$t('lang.lab_linktitle')"></el-table-column>
				<el-table-column prop="image" :label="$t('lang.lab_redZonePicLink')"></el-table-column>
				<el-table-column prop="operation" :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width3">
					<template slot-scope="scope">
						<el-button @click="edit(scope.row.id)">{{$t('lang.btn.modifyBtn')}}</el-button>
						<el-button @click="del(scope.row.id)">{{$t('lang.btn.deleteBtn')}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
				:page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper" :page-count="pageCount" />
		</el-card>
	</div>
</template>

<script>
	/**
	 *@ClassName:addActivityManagement
	 *@Description:红色专区
	 *@author:卢宏禹
	 *@Copyright:格众科技
	 *@date:2020-10-22
	 */
	export default {
		name:'/manage/main.sklGardenAd',
		data() {
			return {
				gardenId: this.$store.getters.gardenId,
				gardenIdList: this.$store.getters.userGardenList,

				pageCount: 0,
				pageNo: 1,
				pageSize: 10,

				redZoneList: [],
				title: '',
			}
		},
		mounted() {
			this.selectList()
		},
		methods: {
			add() {
				this.$router.push({
					name: 'addsklGardenAd'
				})
			},
			selectList() {
				let loading = this.$loading()
				this.$get(
						`/selectSklGardenAdList?pageNo=${this.pageNo}&pageSize=${this.pageSize}&gardenId=${this.gardenId}&title=${this.title}`
					)
					.then(res => {
						// console.log(res)
						this.redZoneList = res.list
						this.pageCount = res.pageCount
						loading.close()
					})
					.catch(err => {
						this.$message.error(err)
						loading.close()
					})
			},
			edit(id) {
				this.$router.push({
					name: 'addsklGardenAd',
					query: {
						id: id
					}
				})
			},
			del(id) {
				let loading = this.$loading()
				let param = {
					id: id
				}
				this.$confirm(
						this.$i18n.t('lang.lab_isdelete'),
						this.$i18n.t('lang.lab_prompt'), {
							confirmButtonText: this.$i18n.t('lang.btn_confirm'),
							cancelButtonText: this.$i18n.t('lang.btn_cancel'),
							type: 'warning'
						}
					).then(() => {
						this.$postJson(`/SklGardenAdDel`, param)
							.then(res => {
								if (res && res.errCode === 0) {
									this.$message({
										type: 'success',
										message: this.$i18n.t('lang.lab_del_success')
									})
									this.selectList()
									loading.close()
								}
							})
							.catch(err => {
								this.$message.error(err)
								loading.close()
							})
					})
					.catch(() => {
						loading.close()
						this.$message({
							type: 'info',
							message: this.$i18n.t('lang.lab_del_can')
						})
					})
			},
			// 点击换页
			handleCurrentChange(val) {
				this.pageNo = val
				this.selectList()
			},
			// 点击更改每页容量
			handleSizeChange(val) {
				this.pageNo = 1
				this.pageSize = val
				this.selectList()
			},
		}
	}
</script>

<style lang="scss">

</style>
